module.exports = __webpack_public_path__ + "static/fighter-dwarf-Bruenor-AYAGWW-9f6c74f5a14348c05d2deb45d1754b71.png";